import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DateTime from "components/Display/ViewDateTime";

const UserSendingInTable = ({ list, onClick }) => {
  if (!list){
    return (
      <div/>
    );
  }
  return (
    <div className="calc-setting-table ">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="4" className="text-left calc-setting-table-header">Notendur sem eru að senda inn í gegnum vefþjónustu</th>
        </tr>
        <tr>
          <th className="text-left">Notandi</th>
          <th className="text-left">Fullt nafn</th>
          <th className="text-left">Fjöldi pakka</th>
          <th className="text-left">Síðasti pakki sendur þann</th>
        </tr>
        </thead>
        <tbody>
        {list.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left"><a onClick={(e) => onClick(e,item)}> {item.sentByUsername} </a> </td>
              <td className="text-left">{item.sentByName} </td>
              <td className="text-center">{item.batchCount.toString()} </td>
              <td className="text-left"><DateTime data={item.lastBatch}/></td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

UserSendingInTable.propTypes = {
  list: PropTypes.array,
  onClick : PropTypes.func
};

export default UserSendingInTable;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Batch/UserSendingInTable.js